export default __webpack_public_path__ + "static/media/linkedin_icon.8b333ad2.svg";